import React, { useEffect, useState } from 'react';
import { models, Report, Embed, service, Page } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import 'powerbi-report-authoring';
import './power-bi.css';
import { inject, observer } from 'mobx-react';

@inject('AuthStore', 'CommonStore')
@observer
class PowerBIEmbedApp extends React.Component {

	constructor(props){
        super(props);		
	}

	// Map of event handlers to be applied to the embedding report
	eventHandlersMap = new Map([
		['loaded', function () {
			// console.log('Report has loaded');
		}],
		['rendered', function () {
			// console.log('Report has rendered');
			
			// Update display message
			// console.log('The report is rendered')
		}],
		['error', function (event) { 
			if (event) {
				console.error(event.detail);
			}
		}]
	]);

	getCurrentScreen = () => {
		const reportName = this.props.path.split('/').pop();
		const currentScreen = this.props.CommonStore.reportDetails.find(
		  (x) => x.screen.name === reportName
		);
			
		return currentScreen;
	  };
	

    render(){
        const  reportDetail  = this.getCurrentScreen();
		const { accessToken } = this.props.AuthStore;
		
		const sampleReportConfig = {
			type: 'report',
			embedUrl: reportDetail ? reportDetail.screen.reportUrl : null,
			tokenType: models.TokenType.Aad,	
			accessToken: accessToken,
			settings: undefined,
		};
	
		return(
			<div>
				{reportDetail && (
                <PowerBIEmbed
				embedConfig = { sampleReportConfig }
				eventHandlers = { this.eventHandlersMap }
				cssClassName = { "report-style-class" }
				getEmbeddedComponent = { (embedObject) => {
					console.log(`Embedded object of type "${ embedObject.embedtype }" received`);
					console.log(embedObject);
					//setReport(embedObject as Report);
				} }				
			/>)}
            </div>
        )
    }
}

export default PowerBIEmbedApp;
